import { FontelloIcon, Grid, useTheme } from '@sport1/react-elements'
import React, { FC } from 'react'
import Touchable from '@sport1/react-elements/Touchable'
import colorPattern from '../DesignSystem/colors'
import useArticleToolbarStyles from './useArticleVariantStyles'
import { ArticleBottomBarProps } from './types'
import Font from '@/Fonts/Font'
import Label from '@/BaseComponents/Label'
import Image from '@/BaseComponents/Image'
import { TestID } from '@/utils/PropTypesDefinitions'

const ArticleBottomBar: FC<ArticleBottomBarProps & TestID> = ({
    size = 'S',
    articleType = 'ARTICLE',
    onPressHome,
    onPressArticle,
    articleImage,
    articleDescription,
    testID,
}) => {
    const { surfaceColors, iconColors, fontColors } = useTheme()
    const {
        height,
        homeIconSize,
        imageWidth,
        arrowAndLabelContainerWidth,
        descriptionFontSize,
        playIconWrapper,
        playIconSize,
        scrollRightIconSize,
        descriptionPadding,
        playIconPosition,
    } = useArticleToolbarStyles(size)

    return (
        <Grid
            minHeight={height}
            height={height}
            backgroundColor={surfaceColors['background-invert']}
            horizontal
            testID={testID ?? 'article-toolbar'}
        >
            <Touchable width={height} onPress={onPressHome} testID="home-area">
                <Grid center>
                    <FontelloIcon
                        name="home"
                        color={iconColors['icon-invert']}
                        fontSize={homeIconSize}
                        textAlign="center"
                    />
                </Grid>
            </Touchable>
            <Touchable onPress={onPressArticle} testID="article-area" expand>
                <Grid horizontal>
                    <Grid
                        noExpand
                        height="100%"
                        maxWidth={imageWidth}
                        minWidth={imageWidth}
                        position="relative"
                    >
                        <Image
                            size="S"
                            imageUrl={articleImage}
                            width={imageWidth}
                            aspectRatio="3:2"
                        />
                        {articleType === 'VIDEO' && (
                            <Grid
                                minHeight={playIconWrapper}
                                maxHeight={playIconWrapper}
                                width={playIconWrapper}
                                backgroundColor={colorPattern.sky}
                                position="absolute"
                                left={playIconPosition}
                                bottom={playIconPosition}
                                center
                                testID="play-video-wrapper"
                            >
                                <FontelloIcon
                                    name="play-active"
                                    color={colorPattern.pearl}
                                    fontSize={playIconSize}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Grid padding={descriptionPadding} flexGrow={1} centerVertical>
                        <Font
                            color={fontColors['font-invert']}
                            numberOfLines={2}
                            fontVariant={descriptionFontSize}
                            fontFamilyVariant="Sport1-Bold-Headline"
                        >
                            {articleDescription}
                        </Font>
                    </Grid>
                    <Grid
                        minWidth={arrowAndLabelContainerWidth}
                        maxWidth={arrowAndLabelContainerWidth}
                        height="100%"
                        center
                        alignRight
                    >
                        <Label labelVariant="highlight" labelSize={size}>
                            Für Dich
                        </Label>
                        <Grid center>
                            <FontelloIcon
                                name="arrow_forward_ios"
                                color={iconColors['icon-invert']}
                                fontSize={scrollRightIconSize}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default ArticleBottomBar
